import React from "react";
import {PanelBody} from "./PanelBody";
import {PanelFooter} from "./PanelFooter";
import {PanelHeading} from "./PanelHeading";
import "./panel.css"

export class Panel extends React.Component {
    render() {
        return (
            <div className={"panel " + this.props.type}>
                <PanelHeading>
                    {this.props.heading}
                </PanelHeading>
                <PanelBody>
                    {this.props.body}
                </PanelBody>
                <PanelFooter>
                    {this.props.footer}
                </PanelFooter>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/panel/Panel.js